// Public: Enum that is used to toggle between different view states in
// components that need to fetch remote data.
export default {
  EMPTY: 'empty',
  LOADING: 'loading',
  ERROR: 'error',
  READY: 'ready',
}
